<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" @submit.native.prevent label-width="80px">
            <el-form-item label-width="0px" prop="name">
                <el-input v-model.trim="searchForm.name" style="width: 280px" maxlength="20"
                          placeholder="请输入学术资源范围名称(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-form-item class="f_r">
                <el-button v-if="hasPermission('academic:academic:academicList:add')" type="primary" @click="addWeb(0)"
                           size="small">新增
                </el-button>
                <el-button v-if="hasPermission('academic:academic:academicList:deleteColumn')" type="primary"
                           @click="deleteWeb()" size="small">删除
                </el-button>
            </el-form-item>
        </el-form>
        <div class="dataBox">
            <el-table
                    :data="dataList"
                    v-loading="loading"
                    size="small" height="100%"
                    class="table" border
                    ref="multipleTable"
                    :row-key="'id'"
                    @selection-change="selectionChangeHandle"
                    @sort-change="sortChangeHandle"
            >
                <el-table-column :reserve-selection="true" type="selection" width="50"/>
                <el-table-column prop="academicName" label="学术资源范围" show-overflow-tooltip></el-table-column>
                <el-table-column prop="academicAddress" label="链接地址" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-link @click="gotoPage(row)" type="primary" style="padding-right: 20px">{{
                                row.academicAddress
                            }}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="academicState" label="状态" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-switch
                                v-model="row.academicState"
                                active-value="1"
                                @change="setType(row)"
                                inactive-value="0">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="createByName" label="添加人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createDate" label="添加时间" sortable show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateDate" label="最后修改时间" sortable show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" min-width="100px" label="操作">
                    <template slot-scope="{row}">
                        <el-button v-if="hasPermission('academic:academic:academicList:edit')" type="text" size="small"
                                   @click="addWeb(2,row)">编辑
                        </el-button>
                        <el-button v-if="hasPermission('academic:academic:academicList:deleteColumn')" type="text"
                                   size="small" @click="deleteWeb(row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <add-academic ref="addAcademic" @refresh="refreshList(1,1)"></add-academic>
    </div>
</template>

<script>
import AddAcademic from "@/views/modules/academic/academic/addAcademic.vue";

export default {
    name: "academicList",
    components: {AddAcademic},
    data() {
        return {
            searchForm: {
                name: '',
                orderBy:"",
                current: 1,
                size: 20,
            },
            total: 0,
            loading: false,
            dataList: [],
            dataListSelect: [],
        }
    },

    mounted() {
        this.refreshList()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            this.loading = true
            this.$axios(this.api.academic.academicresourcesList, this.searchForm).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },
        //排序
        sortChangeHandle (obj) {
            obj.prop = this.getHumpLineName(obj.prop);
            if (obj.order === 'ascending') {
                this.searchForm.orderBy = obj.prop + ' asc'
            } else if (obj.order === 'descending') {
                this.searchForm.orderBy = obj.prop + ' desc'
            } else {
                this.searchForm.orderBy = ''
            }
            this.refreshList(1)
        },
        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.searchForm.orderBy = ''
            this.refreshList(1, 1)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        //切换状态
        setType(row) {
            row.academicState = row.academicState == 1 ? 0 : 1
            this.$axios(this.api.academic.academicresourcesUpdateById, {
                id:row.id,
                academicName: row.academicName,
                academicAddress: row.academicAddress,
                academicState: row.academicState == 1 ? 0 : 1,
            }, 'put').then(data => {
                if (data && data.status) {
                    this.$message.success('状态修改成功')
                    this.refreshList('', 1)
                } else {
                    this.$message.error(data.msg)
                }
            })
        },

        //打开链接地址
        gotoPage(row){
            if (row.academicAddress.includes("https://")) {
                var a = document.createElement("a");
                a.setAttribute("href", row.academicAddress);
                a.setAttribute("target", "_blank");
                a.click();
            } else {
                let path = window.location.protocol + '//' + row.academicAddress
                window.open(path, "_blank")
            }
        },

        //num 0新增 2编辑
        addWeb(num, row) {
            this.$refs.addAcademic.init(num, row)
        },

        //删除
        deleteWeb(row) {
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let statusTrueList = []
            let ids = list.map(item => {
                if (item.academicState == 1){
                    statusTrueList.push(item)
                }
                return item.id
            })
            if (statusTrueList.length != 0) {
                this.$message.warning('请先禁用后再删除！')
                return
            }
            this.$confirm(`您是否确认删除数据?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.academicresourcesRemoveById, {ids}, 'delete').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
    }
}
</script>

<style scoped>

</style>
